var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8313 8.8374C16.8313 8.42319 17.1671 8.0874 17.5813 8.0874C20.6766 8.0874 23.2944 10.1316 24.1584 12.9436L25.5387 10.8732C25.7685 10.5285 26.2341 10.4354 26.5788 10.6651C26.9234 10.8949 27.0165 11.3606 26.7868 11.7052L24.335 15.3829C24.2581 15.4982 24.1549 15.5853 24.0386 15.6417C23.8891 15.7141 23.718 15.7356 23.5538 15.7004C23.4183 15.6716 23.2964 15.6062 23.1988 15.515C23.1587 15.4776 23.1234 15.4365 23.0932 15.3925C23.0097 15.2716 22.9608 15.1249 22.9608 14.9669C22.9608 11.9959 20.5523 9.5874 17.5813 9.5874C17.1671 9.5874 16.8313 9.25162 16.8313 8.8374ZM17.259 13.7892H11C10.1716 13.7892 9.5 14.4608 9.5 15.2892V21.5482C9.5 22.3766 10.1716 23.0482 11 23.0482H17.259C18.0874 23.0482 18.759 22.3766 18.759 21.5482V15.2892C18.759 14.4608 18.0874 13.7892 17.259 13.7892ZM11 12.2892C9.34315 12.2892 8 13.6323 8 15.2892V21.5482C8 23.205 9.34315 24.5482 11 24.5482H17.259C18.9158 24.5482 20.259 23.205 20.259 21.5482V15.2892C20.259 13.6323 18.9158 12.2892 17.259 12.2892H11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotate);
export default __webpack_public_path__ + "static/media/Icon-rotate.f1626c4c82287bda2fa6dd1aff13306d.svg";
export { ForwardRef as ReactComponent };